/**
 * Homepage hero copy — the single source of truth.
 *
 * `HomepageHero.tsx` renders these strings and `scripts/prerender.ts` writes
 * the same bytes into the static `<h1>` / intro paragraph, so the crawled HTML
 * can never drift from what the browser renders.
 *
 * The H1 is rendered as two nowrap lines joined by a single space.
 */
export const HOMEPAGE_H1_LINE_1 = "Louisville's commercial electrical,";
export const HOMEPAGE_H1_LINE_2 = "HVAC & energy contractor.";
export const HOMEPAGE_H1 = `${HOMEPAGE_H1_LINE_1} ${HOMEPAGE_H1_LINE_2}`;

export const HOMEPAGE_LEDE =
  "Industrial plants, commercial facilities, municipal work and residential heating & cooling — one licensed team. Churchill Downs. Freedom Hall. Kentucky International Convention Center.";
